import React from "react";
import { useParams } from "react-router-dom";

import PageSecondaryNavigation, {
  PageNavLink,
} from "ui/PageSecondaryNavigation";
import { useAppConfig } from "providers/WithAppConfig";
import { useRoutes } from "utils/routes";
import { useCurrentOrganization } from "providers/WithCurrentOrganization";

const SettingsNav: React.FunctionComponent = () => {
  const { enterpriseEdition } = useAppConfig();
  const currentOrganization = useCurrentOrganization();
  const { slug: organizationSlug } = currentOrganization;
  const serverGroupCrudEnabled =
    currentOrganization.enabledFeatures.serverGroupCrud;
  const { serverId, serverGroupId } = useParams();
  const {
    collectorSettings,
    serverEdit,
    serverGroupEdit,
    serverServerGroups,
    organizationServersSettings,
    organizationServerGroupsSettings,
    organizationMembers,
    organizationRoles,
    organizationApi,
    organizationSubscription,
    organizationEdit,
    organizationIntegrations,
  } = useRoutes();
  const containingGroups = serverGroupId
    ? currentOrganization.serverGroups.filter((sg) => sg.id === serverGroupId)
    : serverId
    ? currentOrganization.serverGroups.filter((sg) =>
        sg.servers.some((s) => s.humanId === serverId),
      )
    : [];
  const clusterPrimaryHumanId = containingGroups[0]?.primaryServerHumanId;
  const serverSettingsTarget = serverId
    ? serverEdit(serverId)
    : clusterPrimaryHumanId
    ? serverEdit(clusterPrimaryHumanId)
    : organizationServersSettings(organizationSlug);
  return (
    <PageSecondaryNavigation>
      {serverGroupCrudEnabled &&
        (containingGroups.length >= 1 && serverId ? (
          <PageNavLink to={serverServerGroups(serverId)}>
            Server Group Settings
          </PageNavLink>
        ) : serverGroupId && containingGroups.length === 1 ? (
          <PageNavLink to={serverGroupEdit(containingGroups[0].id)}>
            Server Group Settings
          </PageNavLink>
        ) : !serverId && !serverGroupId ? (
          <PageNavLink
            to={organizationServerGroupsSettings(organizationSlug)}
            end={false}
          >
            Server Group Settings
          </PageNavLink>
        ) : null)}
      <PageNavLink to={serverSettingsTarget}>Server Settings</PageNavLink>
      {serverId ? (
        <PageNavLink to={collectorSettings(serverId)}>
          Collector Settings
        </PageNavLink>
      ) : null}
      <PageNavLink to={organizationMembers(organizationSlug)}>
        Members
      </PageNavLink>
      <PageNavLink to={organizationRoles(organizationSlug)}>
        Member Roles
      </PageNavLink>
      <PageNavLink to={organizationApi(organizationSlug)}>
        API Access
      </PageNavLink>
      {!enterpriseEdition && (
        <PageNavLink
          to={organizationSubscription(organizationSlug)}
          end={false}
        >
          Billing
        </PageNavLink>
      )}
      <PageNavLink to={organizationIntegrations(organizationSlug)} end={false}>
        Integrations
      </PageNavLink>
      <PageNavLink to={organizationEdit(organizationSlug)}>
        Other Settings
      </PageNavLink>
    </PageSecondaryNavigation>
  );
};

export default SettingsNav;
